import { render, staticRenderFns } from "./ChatLauncher.vue?vue&type=template&id=1ebdc2fa"
import script from "./ChatLauncher.vue?vue&type=script&lang=js"
export * from "./ChatLauncher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports